import { element } from "prop-types";
import { getCurrencySymbol } from "../../../../../utils/utility";

export default function maxNetValue(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const convertedVendorNetValues = config.data.convertedVendorNetValues;
    const maxNetValue = config.data.maxNetValue;
    let maxTotalNetValue = 0;
    maxNetValue.forEach(element => {
        maxTotalNetValue = maxTotalNetValue + element.value
    })
    const userSelectedVendor = config.data.userSelectedVendor;
    const currencyCode = config.data.currencyCode;
    const quoteStatus = config.data.status;
    const selectedVendorMaxNetValue = config.data.selectedVendorMaxNetValue;
    const region = config.data.region;
    const isNotEditable = quoteStatus === "ACCEPTED" || quoteStatus === "LOST";

    const countryCurrency = config.data.countryCurrency;
    const vendorDropDownOptions = convertedVendorNetValues.map(v => ({ id: v.id, label: v.id, value: v.value }));
    const sortedVendorsList = vendorDropDownOptions.sort((_v1, _v2) => _v2.value - _v1.value); // highest to lowest
    const selectedTotalVendorNetValues = Object.values(config.data.userSelectedTotalVendorNetValue) || [];
    const userSelectedTotalVendorNetValue = selectedTotalVendorNetValues.reduce(
        (previousValue, currentValue) => previousValue + currentValue,
        0
    );

    const getCurrencyCode = (countryCurrency) => {
        //If there is single country listed, return the local currency of it otherwise return USD
        if (countryCurrency && Object.keys(countryCurrency).length === 1) {
            return currencyCode;
        } else {
            if (region === "EMEA") {
                return "EUR";
            }
            return "USD";
        }
    }

    const rawTableData = [
        {
            id: "max_customer_net_value",
            columns: [
                {
                    id: "max_customer_net_value.title",
                    type: "string",
                    value: "max_customer_net_value.title",
                    width: "55",
                    displayAsIs: false
                },
                {
                    id: "max_customer_net_value.empty",
                    type: "string",
                    value: "",
                    width: "20",
                    displayAsIs: true
                },
                {
                    id: "max_customer_net_value.number",
                    type: "string",
                    value: `${getCurrencySymbol(getCurrencyCode(countryCurrency))} ${maxTotalNetValue && maxTotalNetValue.toFixed(2)}`,
                    width: "20",
                    displayAsIs: true,
                    highlightColumn: selectedVendorMaxNetValue === "maxNetValue"
                },
                {
                    id: "max_customer_net_value.checkbox",
                    type: "selectionCheckBox",
                    value: selectedVendorMaxNetValue === "maxNetValue" ? "maxNetValue" : "",
                    width: "5",
                    displayAsIs: true,
                    disabled: isNotEditable ? true : false
                }
            ]
        },
        {
            id: "customize_max_customer_net_value",
            columns: [
                {
                    id: "customize_max_customer_net_value.title",
                    type: "string",
                    value: "customize_max_customer_net_value.title",
                    width: "55",
                    displayAsIs: false
                },
                {
                    id: "customize_max_customer_net_value.vendor_dropdown",
                    type: isNotEditable ? "string" : "select",
                    value: isNotEditable ? vendorDropDownOptions[0]?.id : { options: vendorDropDownOptions, defaultValue: userSelectedVendor },
                    width: "20",
                    displayAsIs: isNotEditable ? true : false
                },
                {
                    id: "customize_max_customer_net_value.number",
                    type: "string",
                    value: `${getCurrencySymbol(getCurrencyCode(countryCurrency))} ${userSelectedTotalVendorNetValue && userSelectedTotalVendorNetValue.toFixed(2)}`,
                    width: "20",
                    displayAsIs: true,
                    highlightColumn: selectedVendorMaxNetValue === "customizedMaxNetValue"
                },
                {
                    id: "customize_max_customer_net_value.checkbox",
                    type: "selectionCheckBox",
                    value: selectedVendorMaxNetValue === "customizedMaxNetValue" ? "customizedMaxNetValue" : "",
                    width: "5",
                    displayAsIs: true,
                    disabled: isNotEditable ? true : false
                }
            ]
        }
    ];

    rawTableData.forEach(row => {
        let rowData = [];
        row.columns.forEach(column => {
            const columnId = column.id;
            rowData.push({
                [columnId]: {
                    id: columnId,
                    columnId: columnId,
                    type: column.type,
                    value: column.value,
                    width: parseInt(column.width),
                    displayAsIs: column.displayAsIs,
                    colSpan: column.colSpan || 0,
                    rowSpan: column.rowSpan || 0,
                    highlightColumn: column.highlightColumn,
                    disabledCheckBox: isNotEditable && column.type === "selectionCheckBox" ? true : false,
                    clickHandler: column.type !== "string" ? e => config.bodyButtonsHandler(e) : null
                }
            })
        });

        tableData.push({
            id: row.id,
            data: rowData
        });
    })

    result['data'] = tableData;

    return result;
}
